'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	_ = require('underscore');

module.exports = function StoryboardController(storyboardModel) {
	/* workflows, event processing */
	let	selectedScene;
	const self = observable(this),
		notInAnyStoryboards = function (scene) {
			return _.size(scene.storyboards) === 0;
		},
		buildStoryboardScene = function (storyboardName, index, sceneType) {
			const result = {
				'storyboards': {}
			};
			result.storyboards[storyboardName] = index;
			if (sceneType) {
				result.type = sceneType;
			}
			return result;
		},
		appendScene = function (storyboardName, nodeId, index, sceneType) {
			const scenes = storyboardModel.getScenesForNodeId(nodeId),
				result = buildStoryboardScene(storyboardName, index, sceneType);
			scenes.push(result);
			storyboardModel.setScenesForNodeId(nodeId, scenes);
		},
		getContext = function () {
			const scenes = storyboardModel.getScenes(),
				currentIndex = selectedScene && scenes && scenes.length && scenes.indexOfScene(selectedScene);
			if (!scenes) {
				return {
					isEnabled: storyboardModel.getInputEnabled()
				};
			}
			return {
				hasScenes: scenes.length > 0,
				notFirst: currentIndex > 0,
				notLast: selectedScene && currentIndex > -1 && currentIndex < scenes.length - 1,
				isEnabled: storyboardModel.getInputEnabled(),
				selectedScene: selectedScene
			};
		},
		sendContext = function () {
			self.dispatchEvent('storyboardContext', getContext());
		};
	self.addScene = function (nodeId, beforeScene, sceneType) {
		let storyboardName = storyboardModel.getActiveStoryboardName(),
			index = 1;
		if (!storyboardName) {
			storyboardName = storyboardModel.createStoryboard();
		}
		if (beforeScene) {
			index = storyboardModel.insertionIndexBefore(beforeScene);
		} else {
			index = storyboardModel.nextSceneIndex();
		}
		if (!index) {
			storyboardModel.rebalanceAndApply([beforeScene], function (newScenes) {
				appendScene(storyboardName, nodeId, storyboardModel.insertionIndexBefore(newScenes[0]), sceneType);
			});
		} else {
			appendScene(storyboardName, nodeId, index, sceneType);
		}
	};
	self.moveSceneAfter = function (sceneToMove, afterScene) {
		if (!sceneToMove) {
			return false;
		}
		if (afterScene && afterScene.ideaId === sceneToMove.ideaId && afterScene.index === sceneToMove.index) {
			return false;
		}

		let newIndex, afterSceneIndex;

		const storyboardName = storyboardModel.getActiveStoryboardName(),
			scenes = storyboardModel.getScenes(),
			currentIndex = scenes && _.indexOf(scenes, _.find(scenes, function (scene) {
				return scene.ideaId === sceneToMove.ideaId && scene.index === sceneToMove.index;
			}));

		if (!scenes || !scenes.length) {
			return false;
		}
		if (currentIndex === -1) {
			return false;
		}
		if (afterScene) {
			if (currentIndex > 0) {
				afterSceneIndex = _.indexOf(scenes, _.find(scenes, function (scene) {
					return scene.ideaId === afterScene.ideaId && scene.index === afterScene.index;
				}));
				if (currentIndex === (afterSceneIndex + 1)) {
					return false;
				}
			}
			newIndex = storyboardModel.insertionIndexAfter(afterScene);
		} else {
			if (currentIndex === 0) {
				return false;
			}
			newIndex = storyboardModel.insertionIndexAfter();
		}
		if (!newIndex) {
			storyboardModel.rebalanceAndApply([sceneToMove, afterScene],
				function (rebalancedScenes) {
					storyboardModel.updateSceneIndex(rebalancedScenes[0], storyboardModel.insertionIndexAfter(rebalancedScenes[1]), storyboardName);
				}
			);
		} else {
			storyboardModel.updateSceneIndex(sceneToMove, newIndex, storyboardName);
		}
		return true;
	};
	self.moveSelectedSceneLeft = function () {
		const scenes = storyboardModel.getScenes(),
			currentIndex = selectedScene && scenes.indexOfScene(selectedScene);
		if (currentIndex === 0) {
			return;
		} else if (currentIndex === 1) {
			self.moveSceneAfter(selectedScene);
		} else {
			self.moveSceneAfter(selectedScene, scenes[currentIndex - 2]);
		}
	};

	self.moveSelectedSceneRight = function () {
		const scenes = storyboardModel.getScenes(),
			currentIndex = selectedScene && scenes.indexOfScene(selectedScene);
		if (currentIndex === scenes.length - 1) {
			return;
		} else {
			self.moveSceneAfter(selectedScene, scenes[currentIndex + 1]);
		}

	};

	self.removeScenesForIdeaId = function (ideaId) {
		const storyboardName = storyboardModel.getActiveStoryboardName(),
			scenes = storyboardName && storyboardModel.getScenesForNodeId(ideaId);
		let didRemoveScene;

		if (!storyboardName) {
			return false;
		}
		_.each(scenes, function (scene) {
			if (scene.storyboards && scene.storyboards[storyboardName]) {
				delete scene.storyboards[storyboardName];
				didRemoveScene = true;
			}
		});
		if (!didRemoveScene) {
			return false;
		}
		storyboardModel.setScenesForNodeId(ideaId, _.reject(scenes, notInAnyStoryboards));
		return true;
	};
	self.removeScene = function (sceneToRemove) {

		if (!sceneToRemove || !sceneToRemove.ideaId || !sceneToRemove.index) {
			if (selectedScene) {
				sceneToRemove = selectedScene;
			} else {
				return false;
			}
		}
		const storyboardName = storyboardModel.getActiveStoryboardName(),
			scenes = storyboardName && storyboardModel.getScenesForNodeId(sceneToRemove.ideaId);

		if (!storyboardName) {
			return false;
		}
		_.each(scenes, function (scene) {
			if (scene.storyboards && scene.storyboards[storyboardName] && scene.storyboards[storyboardName] === sceneToRemove.index) {
				delete scene.storyboards[storyboardName];
			}
		});
		storyboardModel.setScenesForNodeId(sceneToRemove.ideaId, _.reject(scenes, notInAnyStoryboards));
	};
	self.setSelectedScene = function (newSelected) {
		if (selectedScene && selectedScene.matchesScene(newSelected)) {
			return;
		}
		selectedScene = newSelected;
		sendContext();
	};
	self.getSelectedScene = function () {
		return selectedScene;
	};
	storyboardModel.addEventListener('inputEnabled storyboardChangeComplete', sendContext);
	storyboardModel.addEventListener('storyboardSceneMoved', function (movedDelta) {
		if (movedDelta.from.matchesScene(selectedScene)) {
			self.setSelectedScene(movedDelta.to);
		}
	});
	storyboardModel.addEventListener('storyboardSceneRemoved', function (sceneRemoved) {
		const remainingScenes = storyboardModel.getScenes();
		let nextOne;
		if (_.isEmpty(remainingScenes)) {
			self.setSelectedScene(false);
		}
		if (sceneRemoved.matchesScene(selectedScene)) {
			nextOne = _.find(remainingScenes, function (scene) {
				return scene.index > selectedScene.index;
			});
			if (!nextOne) {
				nextOne = remainingScenes[remainingScenes.length - 1];
			}
			self.setSelectedScene(nextOne);
		}
	});
};

